import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ProctoringService {

  constructor(public hs: HttpService) { }

  async get_face_logs_list(filters: any) {
    try {
      let response = await this.hs.get('/proctoring/get-face-logs-list', filters);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
